import React, { useEffect } from "react";

import LandingHeader from "../header";

import "./disclaimer.css";
import Footer from "../footer";

function Disclaimer() {
  // Scrolls to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="disclaimer-wrapper">

      {/* Website Header */}
      <div className="disclaimer-header">
        <LandingHeader />
      </div>


      {/* Page Title */}
      <div className="disclaimer-title">
        <h1>Disclaimer</h1>

        <p>
          Last Updated: August 13, 2026
        </p>
      </div>


      {/* Disclaimer Content */}
      <div className="disclaimer-content">

        <section>
          <h2>1. General Disclaimer</h2>

          <p>
            The information, services, content, and functionality provided
            through QuallyHire AI and NuJobs are intended to support
            recruitment, hiring, job discovery, and related activities.
          </p>

          <p>
            HMW Communications Private Limited ("HMW Communications",
            "we", "us", or "our") makes reasonable efforts to provide
            useful and reliable services. However, we do not guarantee
            that all information available through our platforms is
            accurate, complete, current, or error-free.
          </p>
        </section>


        <section>
          <h2>2. Job Listings</h2>

          <p>
            NuJobs may contain job opportunities submitted by employers,
            recruiters, staffing organizations, or other third parties.
          </p>

          <p>
            HMW Communications does not guarantee the accuracy,
            completeness, availability, legitimacy, or authenticity of
            every job listing published through the platform.
          </p>

          <p>
            Job availability, salary, location, responsibilities,
            qualifications, company information, and other job details
            may change without notice.
          </p>

          <p>
            Candidates should independently verify job opportunities and
            the identity of employers or recruiters before providing
            sensitive information or accepting an employment opportunity.
          </p>
        </section>


        <section>
          <h2>3. No Guarantee of Employment</h2>

          <p>
            Use of NuJobs does not guarantee that a candidate will receive
            an interview, job offer, employment, promotion, or any other
            employment-related outcome.
          </p>

          <p>
            Similarly, use of QuallyHire AI does not guarantee that an
            employer or recruiter will identify, interview, or hire a
            suitable candidate.
          </p>

          <p>
            Hiring and employment decisions are made solely by the
            relevant employer or authorized decision-maker.
          </p>
        </section>


        <section>
          <h2>4. AI and Automated Results</h2>

          <p>
            QuallyHire AI and related services may use artificial
            intelligence, algorithms, automation, and other technologies
            to assist with recruitment-related activities.
          </p>

          <p>
            Automated results may include resume processing, job
            description analysis, candidate recommendations, matching,
            ranking, evaluations, or other recruitment-related outputs.
          </p>

          <p>
            AI-generated and automated results may contain inaccuracies,
            omissions, or errors.
          </p>

          <p>
            Users should review and independently verify AI-generated or
            automated information before relying upon it.
          </p>

          <p>
            AI-assisted results should not be considered a substitute for
            human judgment, professional evaluation, or appropriate
            recruitment practices.
          </p>
        </section>


        <section>
          <h2>5. Candidate Information</h2>

          <p>
            Candidate profiles, resumes, skills, experience, education,
            contact information, and other information submitted to our
            platforms are provided by users or other authorized parties.
          </p>

          <p>
            HMW Communications does not guarantee that candidate
            information is accurate, complete, current, or independently
            verified.
          </p>

          <p>
            Employers and recruiters are responsible for conducting
            appropriate verification and assessment before making
            employment decisions.
          </p>
        </section>


        <section>
          <h2>6. Employer and Recruiter Information</h2>

          <p>
            Information about employers, recruiters, staffing
            organizations, and other organizations may be provided by
            those organizations or other sources.
          </p>

          <p>
            We do not guarantee that all organization information,
            company descriptions, job postings, or other employer-related
            information is complete, accurate, or current.
          </p>
        </section>


        <section>
          <h2>7. Fraud and Scam Warning</h2>

          <p>
            Users should exercise caution when communicating with
            employers, recruiters, or other individuals through or in
            connection with our services.
          </p>

          <p>
            HMW Communications will not normally require candidates to
            make payments to obtain employment opportunities.
          </p>

          <p>
            Users should be cautious of requests for money, banking
            information, passwords, identity documents, or other sensitive
            information from unknown or unverified parties.
          </p>

          <p>
            If you believe that a job listing or communication is
            fraudulent or suspicious, please contact us through the
            appropriate support channel.
          </p>
        </section>


        <section>
          <h2>8. Third-Party Websites and Services</h2>

          <p>
            Our websites and applications may contain links to third-party
            websites, services, or applications.
          </p>

          <p>
            These third-party services are not controlled by HMW
            Communications.
          </p>

          <p>
            We are not responsible for the content, availability,
            security, privacy practices, accuracy, or functionality of
            third-party websites or services.
          </p>

          <p>
            Users should review the terms and privacy policies of
            third-party services before using them.
          </p>
        </section>


        <section>
          <h2>9. Platform Availability</h2>

          <p>
            We make reasonable efforts to maintain the availability and
            reliability of our services.
          </p>

          <p>
            However, we do not guarantee that QuallyHire AI, NuJobs, or
            any related service will always be available, uninterrupted,
            secure, or free from errors.
          </p>

          <p>
            Services may be temporarily unavailable because of maintenance,
            upgrades, technical issues, security incidents, network
            problems, or circumstances outside our reasonable control.
          </p>
        </section>


        <section>
          <h2>10. User Responsibility</h2>

          <p>
            Users are responsible for evaluating information obtained
            through our services and determining whether that information
            is appropriate for their particular circumstances.
          </p>

          <p>
            Employers and recruiters are responsible for their hiring
            decisions, recruitment practices, job postings, candidate
            evaluations, and compliance with applicable laws.
          </p>

          <p>
            Candidates are responsible for the information they provide,
            the applications they submit, and their interactions with
            employers and recruiters.
          </p>
        </section>


        <section>
          <h2>11. No Professional Advice</h2>

          <p>
            Information provided through our services is not intended to
            constitute legal, financial, employment, human resources, or
            other professional advice.
          </p>

          <p>
            Users should obtain appropriate professional advice where
            necessary for their specific circumstances.
          </p>
        </section>


        <section>
          <h2>12. Limitation of Liability</h2>

          <p>
            To the maximum extent permitted by applicable law, HMW
            Communications and its officers, employees, affiliates,
            service providers, and representatives will not be liable for
            losses or damages arising from reliance on job listings,
            candidate information, employer information, AI-generated
            results, automated recommendations, third-party services, or
            other information provided through our platforms.
          </p>

          <p>
            Nothing in this Disclaimer is intended to exclude or limit
            liability that cannot lawfully be excluded or limited under
            applicable law.
          </p>
        </section>


        <section>
          <h2>13. Changes to This Disclaimer</h2>

          <p>
            We may update this Disclaimer from time to time to reflect
            changes in our services, technology, business practices, or
            applicable legal requirements.
          </p>

          <p>
            Updated versions will be posted on this page together with a
            revised "Last Updated" date.
          </p>
        </section>


        <section>
          <h2>14. Contact Us</h2>

          <p>
            If you have questions regarding this Disclaimer, please
            contact us at:
          </p>

          <div className="disclaimer-contact">
            <strong>HMW Communications Private Limited</strong>

            <br />

            Email: support@hmwcomm.com

            <br />

            QuallyHire AI / NuJobs
          </div>
        </section>

      </div>


      {/* Website Footer */}
      <Footer />

    </div>
  );
}

export default Disclaimer;